import { api } from '@/f1/service';
import { Switch as cSwitch } from '@coreui/vue';
import Language from './language';

//restful api
//import { wmds as ws } from '@/f1/service/api'

//i18n_data
import i18n_toastr from './i18n_data'
import i18n_data from '@/component/i18n_data';

export default {
  components : { cSwitch, Language },
  data : () => {
    return {
      confirm: false,
      add: false,
      lock: true,
      model : { group: {}, code : '' },
    }
  },
  computed: {
  },
  methods: {
    regex_valid: (c, f = '') => {
      if(!c) { return false }
      try { new RegExp(c, f); return true } catch(e) { return false }
    },
    cancel() { this.$router.replace({ name: 'wmds_pattern', params: { id: this.model.id }}) },
    edit() { this.$router.replace({ name: 'wmds_pattern', params: { id: this.model.id, tag: 'edit' }}); },
    async remove() {
      try{
        await api.wmds.WMDS_Call('pattern', 'delete', {id :this.model.id})
        //await ws.pattern.delete({id :this.model.id})
        this.$parent.$emit('refresh'), this.$toastr.s(`${i18n_data._i18n_success.removed[this.i18n]}`), this.list()
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.remove_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    },
    list() { this.$router.push({ name: 'wmds_pattern'}); },
    async save() {
      if(!(this.model.code || '').trim()) { return this.$toastr.e(`${i18n_toastr._i18n_error.required_code[this.i18n]}`); }
      if(!this.regex_valid(this.model.code)) { return this.$toastr.e(`${i18n_data._i18n_error.regex_valid[this.i18n]}`); }

      try {
        let rs = await api.wmds.WMDS_Call('pattern', this.model.id ? 'update' : 'insert', this.model);

        // let check_id = this.model.id ? `${await ws.pattern.update(this.model)}` : `${await ws.pattern.insert(this.model)}`
        // let rs = check_id

        if(rs.error) { return this.$toastr.e(`${i18n_data._i18n_error.save_failed[this.i18n]}`) }

        this.$toastr.s(`${i18n_data._i18n_success.saved[this.i18n]}`);
        this.$parent.$emit('refresh'); this.cancel();
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.save_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText)  }
      this.lock = true;
    },
    async get({ id, tag } = this.$route.params) {
      console.log('pattern.detail.vue', 'load item', id);
      if(id === 'add') { this.add = true; this.lock = false; this.model = { is_alive: true, level: 'W', type: 'U' }; return; }
      try{
        this.add = false;
        this.lock = (tag !== 'edit');
        let rs = await api.wmds.WMDS_Call('pattern', 'detail', { id : id })
        //let rs = await ws.pattern.detail({ id : id })
        this.model = Object.assign({ group: {} }, this.model, rs.body)
      } catch(e) { this.$toastr.e(e.data ? `${i18n_data._i18n_error.load_failed[this.i18n]}` : e.data.message ? e.data.message : e.statusText) , this.list() }
    }
  },
  watch: { '$route' (to, from) { this.get(to.params); } },
  created() { console.log('pattern.detail.vue', 'created'); },
  destroyed() { console.log('pattern.detail.vue', 'destroyed'); },
  mounted() {
    console.log('pattern.detail.vue', 'mounted');
    this.get(this.$route.params);
  },
}
